import { render, staticRenderFns } from "./detailLayout.vue?vue&type=template&id=41bd6e1c&"
import script from "./detailLayout.vue?vue&type=script&lang=js&"
export * from "./detailLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports